<template>
    <div class="vh-100 bg-grey">
        <!-- HEADER -->
        <div class="header-top bg-white">

            <!-- Normal Header -->
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row w-limit">
                    <div class="col-md-2 col-sm-2 col-2 remove-padding">
                        <div @click="$router.go(-1)">
                            <div class="header-icon icon-arrow-left"></div>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
                            Detail {{ section }}
                        </h6>
                    </div>
                    <div data-v-8dbe3aee="" class="col-md-2 col-sm-2 col-2"></div>
                </div>
            </div>
        </div>

        <!-- MAIN NORMAL CONTENT -->
        <main class="page-wrapper main-page w-limit">
            <div>
                <div class="main-content-data">
                    <a class="f-16 f-semi f-c-blue dropdown-toggle" href="#" data-toggle="dropdown">
                        {{ filtering }}
                    </a>
                    <div class="dropdown-menu mod">
                        <div class="dropdown-item plain">Penerimaan:</div>
                        <a id="cash" @click="FilterData('cash')" class="dropdown-item">Cash</a>
                        <a id="debit" @click="FilterData('debit')" class="dropdown-item">Transfer</a>
                        <a id="edc" @click="FilterData('edc')" class="dropdown-item">EDC</a>
                        <a id="paylink" @click="FilterData('paylink')" class="dropdown-item">Paylink</a>
                        <div class="dropdown-item plain">Pengeluaran:</div>
                        <a id="pengeluaran" @click="FilterData('pengeluaran')" class="dropdown-item">Biaya</a>
                    </div>

                    <div class="main-content">
                        <div class="f-16 f-semi f-c-midgrey m-t-10"> Total
                            <span class="f-bold f-c-black"> {{ totalKeuangan | currency }} </span>
                        </div>
                        <div class="f-14 f-c-midgrey m-t-8">{{ periodeFormat }}</div>
                        <div class="list-card">
                            <div class="flex-1">
                                <div
                                    class="set-card set-card-height"
                                    v-for="(dataEach, index) in dataListRincianKeuangan"
                                    :key="index"
                                    @click="goToDetailPenerimaan(dataEach)"
                                >
                                    <div class="row add-padding-default">
                                        <div class="col-md-3 col-sm-3 col-3  remove-margin remove-padding">
                                            <figure class="box">
                                                <img v-if="dataEach.logo_url != ''" v-bind:src="dataEach.logo_url"
                                                     alt=""
                                                     style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
                                                <img v-else src="@/assets/gambar/Rectangle43.svg" alt=""
                                                     style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;">
                                            </figure>
                                        </div>
                                        <div class="col-md-8 col-sm-8 col-8  remove-padding">
                                            <div class="font-16 remove-margin font-weight-bold nomore">
                                                {{ dataEach.nama }}
                                            </div>
                                            <div class="font-16 remove-margin f-c-midgrey m-t-4 nomore">
                                                {{ dataEach.total_keuangan | currency }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br><br>
                        </div>
                    </div>
                </div>
                <div class="loader"></div>
            </div>
        </main>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";
    import { moduleName } from "../store/state";
    export default {
        name: "ListKasLaci",
        props: {
            tipe: {
                type: String,
                default: null,
            },
            periodProps: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                jenisPeriode: "bulan_ini",
                dataListRincianKeuangan: [],
                totalSatuan: 0,
                totalHarga: 0,
                totalKeuangan: 0,
                periodeFormat: "",
                satuanGlobal: "",
                filtering : "",
                status_text_data: "",
                section: "Penerimaan",
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                tipePembayaran: null,
                periode: {},
            }
        },
        mounted() {
            $(".loader").hide()
            this.FilterPendapatanPengeluaran(this.detailPenerimaan.tipePembayaran, this.detailPenerimaan.periode)
        },
        computed: { 
            ...mapGetters(moduleName, {
                detailPenerimaan: "detailPenerimaan",
            }),
        },
        methods: {
            goToDetailPenerimaan(dataOutlet) {
                if (this.tipePembayaran == "debit" || this.tipePembayaran == "edc") {
                    
                }
                else {
                    return
                }
                dataOutlet.tanggal_awal = this.$moment(this.periode.tanggal_awal).format("YYYY-MM-DD")
                dataOutlet.tanggal_akhir = this.$moment(this.periode.tanggal_akhir).format("YYYY-MM-DD")
                this.$store.commit('detailPenerimaanModule/setOutletData', dataOutlet)
                this.$store.commit("filterGlobalModule/resetFilterItem");
                this.$store.commit("filterGlobalModule/resetFilter");
                let filterItem = this.$store.state.filterGlobalModule.filterItem
                filterItem.periode.filterBy = this.periodProps == 'bulan_ini' ? 'bulan' : 'periode'
                if (filterItem.periode.filterBy == 'periode') {
                    filterItem.periode.startDate = dataOutlet.tanggal_awal
                    filterItem.periode.endDate = dataOutlet.tanggal_akhir
                }
                if (filterItem.periode.filterBy == 'bulan') {
                    filterItem.periode.month = this.$moment(this.periode.tanggal_akhir).format("YYYY-MM")
                }
                const filter = {
                    idoutlet: dataOutlet.idoutlet, 
                    limit: 20,
                    offset: 0,
                    ...(filterItem.periode.filterBy == 'bulan' && {bulan: filterItem.periode.month}),
                    periode_by: filterItem.periode.filterBy,
                    tanggal_awal: dataOutlet.tanggal_awal,
                    tanggal_akhir: dataOutlet.tanggal_akhir,
                }
                this.$store.commit("filterGlobalModule/setFilterItem", filterItem)
                this.$store.commit("detailPenerimaanModule/setFilterTransaksi", {filter: filter, filterCount: 1})
                this.$store.commit("detailPenerimaanModule/setDefaultFilter", {filter: filter, filterItem: filterItem})
                this.$router.push({
                    path: '/detail-penerimaan/outlet/' + dataOutlet.idoutlet +'/' + this.tipePembayaran,
                })
            },
            toTop(){
                window.scrollTo(0, 0)
            },
            FilterPendapatanPengeluaran(tipe, periode) {
                this.jenisPeriode = periode
                this.getDataListPendapatanPengeluaran(tipe, periode)
                $(".main-content").hide()
            },
            FilterData(params) {
                this.$store.commit('detailPenerimaanModule/setDetailPenerimaan', {
                    tipePembayaran: params,
                    periode: this.jenisPeriode
                })
                this.getDataListPendapatanPengeluaran(params, this.jenisPeriode)
                $(".main-content").hide()
            },
            async getDataListPendapatanPengeluaran(params, periods) {
                this.tipePembayaran = params
                $(".loader").show()
                $(".dropdown-item").removeClass("active")
                switch (params) {
                    case "cash":
                        this.section = "Penerimaan"
                        this.filtering = "Penerimaan Cash"
                        $("#"+params).addClass("active")
                        break;
                    case "debit":
                        this.section = "Penerimaan"
                        this.filtering = "Penerimaan Transfer"
                        $("#"+params).addClass("active")
                        break;
                    case "paylink":
                        this.section = "Penerimaan"
                        this.filtering = "Penerimaan Paylink"
                        $("#"+params).addClass("active")
                        break;
	                case "edc":
		                this.section = "Penerimaan"
		                this.filtering = "Penerimaan EDC"
		                $("#"+params).addClass("active")
		                break;
                    case "pengeluaran":
                        this.section = "Pengeluaran"
                        this.filtering = "Pengeluaran Biaya"
                        $("#"+params).addClass("active")
                        break;
                    default:
                        this.section = "Pendapatan"
                }
                this.dataListRincianKeuangan = []
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_pendapatan_pengeluaran_v2?jenis_data=' + params + '&periode=' + periods, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            $(".main-content").show()
                            this.periodeFormat = response.data.data.periode
                            this.periode = {
                                tanggal_awal: response.data.data.periode_awal,
                                tanggal_akhir: response.data.data.periode_akhir
                            }
                            //iterate list data outlet
                            this.totalKeuangan = 0
                            this.dataListRincianKeuangan = []
                            response.data.data.result.forEach(item => {
                                let imgPrefix = item.logo_url.includes('bos_revamp/') ? 'https://statics.smartlink.id/ember-e-dalbo/' : 'https://res.cloudinary.com/sinadme/c_scale,h_200/'
                                let uang = item.total_nominal_pengeluaran || item.total_nominal_pembayaran
                                this.dataListRincianKeuangan.push({
                                    idoutlet: item.idoutlet,
                                    nama: item.nama,
                                    logo_url: item.logo_url != '' ? imgPrefix + item.logo_url : '',
                                    total_keuangan: uang
                                })
                                this.totalKeuangan += uang
                            });
                            // console.log(this.dataListRincianKeuangan)
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
                $(".loader").hide()
            },
        }
    }
</script>
<style scoped>
    .header-icon {
        height: 25px;
        width: 25px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .main-content-data {
        padding: 20px 20px;
    }

    .list-card {
        margin-top: 15px;
    }

</style>
<style>
    .loader {
        -webkit-animation: spin 1s linear infinite;
        animation: spin 1s linear infinite;
        border: 3px solid #ddd;
        border-top: 3px solid #aeb0b0;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        margin: 30% auto;
    }

    @-webkit-keyframes spin {
        to {
            border-top-color: #aeb0b0;
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes spin {
        to {
            border-top-color: #aeb0b0;
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .set-card-height {
        height: 80px;
    }

</style>